<template>
        <section>
            <div class="container">
                <div class="my-lg-5 my-4">
                    <img src="https://cdn.studiesweekly.com/store/productpage-ext_13.jpg" class="img-fluid w-100">
                </div>

                <div>
                    <h4>
                        Weekly Curriculum Map / Standards Correlation
                    </h4>
                    <p class="text-muted mb-3">
                        Studies Weekly core curriculum simplifies standards coverage with Social Studies ELA integration.
                    </p>

                    <div class="btn-group mb-3 w-100">
                        <a
                            v-for="publication in publications"
                            :key="publication.id"
                            :href="'https://app.studiesweekly.com/online/standards/proxy_correlations/' + publication.sku + '/' + publication.state"
                            class="btn text-center"
                            :class="{
                                'kindergarten': publication.grade == 0,
                                'first-grade': publication.grade == 1,
                                'second-grade': publication.grade == 2,
                                'third-grade': publication.grade == 3,
                                'fourth-grade': publication.grade == 4,
                                'fifth-grade': publication.grade == 5,
                                'sixth-grade': publication.grade == 6,
                                'seventh-grade': publication.grade == 7,
                                'eighth-grade': publication.grade == 8
                            }"
                            target="_blank"
                        >
                            <template v-if="publication.grade == 0">
                                K
                            </template>
                            <template v-else>
                                {{publication.grade}}
                            </template>
                        </a>
                    </div>

                    <small class="text-info">
                        * Click a grade to view the complete standards coverage.
                    </small>
                </div>

                <div class="my-lg-5 my-4">
                    <div class="row">
                        <div class="col-lg-6 align-self-center mb-lg-0 mb-3">
                            <img src="https://cdn.studiesweekly.com/store/productpage05.jpg" class="img-fluid w-100">
                        </div>
                        <div class="col-lg-6 align-self-center">
                            <h5>Teacher Resources Included</h5>
                            <p>Studies Weekly provides lesson-ready materials to help teachers save time and focus on tailoring the instruction to meet the needs of each student.</p>
                            <ul class="list-group">
                                <li class="list-group-item">Lesson Plans</li>
                                <li class="list-group-item">Assessments</li>
                                <li class="list-group-item">Worksheets</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>

<script>
export default {
    data: () => ({
        editor: null
    }),
    props: ['block', 'publications'],
    components: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>
